import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import AppShell from "../components/AppShell";
import { UsersThree, Ticket, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function MyEvents() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/my/events");
        setItems(data);
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <AppShell>
      <div className="mb-8">
        <div className="mono-font text-[10px] tracking-[0.3em] uppercase text-white/40">Member Portal</div>
        <h1 className="heading-font text-4xl sm:text-5xl font-black tracking-tighter mt-2">Events I Distribute</h1>
        <p className="mono-font text-xs text-white/50 mt-3 max-w-2xl">
          Events you have been invited to as a distributing member. Request more tickets, issue them to buyers, and confirm payments.
        </p>
      </div>
      {loading ? (
        <div className="mono-font text-sm text-white/40 py-16 text-center">Loading…</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-white/15 p-16 text-center">
          <UsersThree size={40} weight="duotone" className="mx-auto text-white/40" />
          <div className="heading-font text-xl font-bold mt-4">You are not a member of any events yet</div>
          <div className="mono-font text-xs text-white/50 mt-2">Ask an event creator to invite your email address.</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="my-events-grid">
          {items.map(({ event, membership }) => {
            const avail = membership.total_allocated - membership.issued_count;
            return (
              <Link key={membership.membership_id} to={`/member/events/${event.event_id}`}
                data-testid={`my-event-card-${event.event_id}`}
                className="group border border-white/10 hover:border-[#00FF66]/60 hover:-translate-y-1 transition-all duration-200 bg-[#0A0A0C]">
                <div className="aspect-[16/9] bg-black relative overflow-hidden border-b border-white/10">
                  {event.design_url ? (
                    <img src={event.design_url} alt={event.title} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center aura-grid">
                      <Ticket size={48} weight="duotone" className="text-white/20" />
                    </div>
                  )}
                </div>
                <div className="p-5">
                  <div className="heading-font text-lg font-bold tracking-tight truncate">{event.title}</div>
                  <div className="mono-font text-[10px] text-white/40 mt-1 truncate">{event.venue || "—"}</div>
                  <div className="mt-4 grid grid-cols-3 gap-2">
                    <div>
                      <div className="mono-font text-[9px] tracking-widest uppercase text-white/40">Cap</div>
                      <div className="mono-font text-sm text-white">{membership.allocation_cap}</div>
                    </div>
                    <div>
                      <div className="mono-font text-[9px] tracking-widest uppercase text-white/40">Alloc</div>
                      <div className="mono-font text-sm text-white">{membership.total_allocated}</div>
                    </div>
                    <div>
                      <div className="mono-font text-[9px] tracking-widest uppercase text-white/40">Avail</div>
                      <div className={`mono-font text-sm ${avail === 0 ? "text-[#FF0033]" : "text-[#00FF66]"}`}>{avail}</div>
                    </div>
                  </div>
                  <div className="mt-4 inline-flex items-center gap-2 mono-font text-[10px] tracking-[0.25em] uppercase text-white/60 group-hover:text-[#00FF66] transition-colors duration-200">
                    Open Portal <ArrowRight size={12} weight="bold" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </AppShell>
  );
}
